import { type CategoryTreeSubjectNameData } from '@/api';

export const getCategoryName = (
  categoryTreeSubjectNameData?: CategoryTreeSubjectNameData,
) => {
  if (!categoryTreeSubjectNameData) return 'ZEP QUIZ';
  return (
    categoryTreeSubjectNameData.subSubjectName ??
    categoryTreeSubjectNameData.subjectName
  );
};
